import Embroidered from '../../images/PortfolioImg/Patches/Embroidered Patches/E1.jpg'
import PVC from '../../images/PortfolioImg/Patches/PVC Patches/P1.jpg'
import woven from '../../images/PortfolioImg/Patches/woven patches/woven15.jpg'
import Sublimated from '../../images/PortfolioImg/Patches/sublimated patches/sublimated1.jpg'
import Leather from '../../images/PortfolioImg/Patches/Leather Patches/L3.jpg'
import sequin from '../../images/PortfolioImg/Patches/Sequince Patches/s3.jpg'
import Chenille from '../../images/PortfolioImg/Patches/Chenille Patches/C4.jpg'
import digi from '../../images/PortfolioImg/Patches/puffimage.jpeg'


const PatchesData = [
    {
      id: 1,
      name: "Embroidered Patches",
      description: "High-quality embroidered patches for jackets, hats, and bags. Custom designs available.",
      patch:"Patch1",
      "image": Embroidered
    },
    {
      id: 2,
      name: "Puff Embroidered Patches",
      description: "Easy-to-apply iron-on patches for quick customization of clothes, backpacks, and other fabric items.",
      patch:"Patch2",
      "image": digi
    },
    {
      id: 3,
      name: "PVC Patches",
      description: "Durable and weather-resistant PVC patches for outdoor gear, military uniforms, and tactical accessories.",
      patch:"Patch3",
      "image": PVC
    },
    {
      id: 4,
      name: "Woven Patches",
      description: "Thin and smooth woven patches that are ideal for intricate designs and logos.",
      patch:"Patch4",
      "image": woven
    },
    {
      id: 5,
      name: "Sublimation Patches",
      description: "Vibrant full-color sublimated patches ideal for custom designs on clothing, bags, and accessories.",
      patch:"Patch5",
      "image": Sublimated
    },
    {
      id: 6,
      name: "Leather Patches",
      description: "Custom leather patches perfect for rustic, vintage, or high-end fashion designs.",
      patch:"Patch6",
      "image": Leather
    },
    {
      id: 7,
      name: "Chenille Patches",
      description: "Soft, plush chenille patches commonly used for sports jerseys, varsity jackets, and custom apparel.",
      patch:"Patch7",
      "image": Chenille
    },
    {
      id: 8,
      name: "Sequin Patches",
      description: "Sparkling sequin patches ideal for adding a touch of glamour to clothing, accessories, and costumes.",
      patch:"Patch8",
      "image": sequin
    },
    // {
    //   id: 9,
    //   name: "3D Patches",
    //   description: "Patches with raised designs for a more tactile and eye-catching effect, perfect for branding.",
    //   patch:"Patch9",
    //   "image": digi
    // }
  ];
  
  export default PatchesData;
  